// generateReceiptPDF.js
import React from 'react';
import LogoHpa from './images/logo.png';

export const genererPDF = (Client, modePaiement, formData, ClientEnregistre, selectedData = null) => {
  const ClientData = Client || ClientEnregistre;
  const paiement = modePaiement || (formData ? formData.mode_Paie_OP : '');

  // Récupérer les analyses soit de ClientData.analyses, soit de selectedData
  const analysesAfficher = ClientData.analyses || (selectedData ? selectedData.analyses : []);

  // Récupérer les actes de consultation soit de ClientData.actes, soit de selectedData
  const actesConsultation = ClientData.actes || (selectedData ? selectedData.actes : []);

  // Calculer le total des analyses
  const totalAnalyses = analysesAfficher.reduce((sum, analyse) => sum + (analyse.prix || 0), 0);

  // CORRECTION ICI : Utiliser 'montant' au lieu de 'prix'
  const totalActes = actesConsultation.reduce((sum, acte) => sum + (acte.montant || acte.prix || 0), 0);

  // Déterminer si c'est une consultation
  const isConsultation = ClientData.service === 'consultation' || actesConsultation.length > 0;

  // Déterminer si c'est un laboratoire
  const isLaboratoire = ClientData.service === 'laboratoire' || analysesAfficher.length > 0;

  // Montant total
  const montantTotal = ClientData.montant || (totalActes + totalAnalyses);

  console.log('🔍 generateReceiptPDF - DÉBOGAGE:'); // AJOUTER
  console.log('   - actesConsultation:', actesConsultation);
  console.log('   - totalActes:', totalActes);
  console.log('   - totalAnalyses:', totalAnalyses);
  console.log('   - montantTotal:', montantTotal);

  return (
    <div className="pdf-preview">
      <div className="pdf-a4-portrait">
        {/* Copie Client */}
        <div className="pdf-copy-a5 Client-copy">
          <div className="pdf-header">
            <img src={LogoHpa} alt="LNE" className="pdf-logo" />
            <div className="pdf-title">
              <h2>LNE - Ndjamena</h2>
            </div>
          </div>

          <div className="pdf-info">
            <div className="pdf-number">
              <strong>REÇU N°: {ClientData.numClient}</strong>
            </div>
          </div>

          <div className="Client-info-pdf">
            {/* Informations Client */}
            <div className="info-basics">
              <div className="info-line">
                <span className="label">Nom du Client:</span>
                <span className="value">{ClientData.nomClient}</span>
                <span>' ---- '</span>
                <span className="label">Téléphone:</span>
                <span className="value">{ClientData.numAirTel || 'N/A'}</span>
                <span>' ---- '</span>
                Date: {new Date(ClientData.dateCreation || ClientData.dateModification || new Date()).toLocaleDateString('fr-FR')}
                <span>' ---- '</span>
                Heure: {new Date(ClientData.dateCreation || ClientData.dateModification || new Date()).toLocaleTimeString('fr-FR')}
              </div>
            </div>

            {/* Sections adjacentes : Détail Consultation et/ou Détail Analyses */}
            <div className="adjacent-sections">
              {/* Section Détail Consultation (à gauche si actes existent) */}
              {actesConsultation.length > 0 && (
                <div className="consultation-section-adjacent">
                  <div className="section-title consultation-title">DÉTAIL CONSULTATION</div>
                  <div className="section-content">
                    {actesConsultation.map((acte, index) => (
                      <div key={index} className="item-line">
                        <span className="item-nom">{acte.nom || acte.name || 'Acte médical'}</span>
                        <span className="item-prix">
                          {/* CORRECTION ICI AUSSI */}
                          {(acte.montant || acte.prix || 0).toLocaleString()} FCFA
                        </span>
                      </div>
                    ))}
                    <div className="section-total consultation-total">
                      <span>Total Consultation:</span>
                      {/* CORRECTION ICI : Remplacer actesSelectionnes par totalActes */}
                      <span className="total-amount">{totalActes.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              )}

              {/* Section Détail Analyses (à droite si analyses existent) */}
              {analysesAfficher.length > 0 && (
                <div className="analyses-section-adjacent">
                  <div className="section-title analyses-title">DÉTAIL DES ANALYSES</div>
                  <div className="section-content">
                    {analysesAfficher.map((analyse, index) => (
                      <div key={index} className="item-line">
                        <span className="item-nom">{analyse.nom || 'Analyse'}</span>
                        <span className="item-prix">
                          {(analyse.prix || 0).toLocaleString()} FCFA
                        </span>
                      </div>
                    ))}
                    <div className="section-total analyses-total">
                      <span>Total Analyses:</span>
                      <span>{totalAnalyses.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Si seulement une section existe, elle prend toute la largeur */}
            {(actesConsultation.length > 0 && analysesAfficher.length === 0) && (
              <div className="single-section">
                <div className="single-section-content consultation-section-adjacent">
                  <div className="section-title consultation-title">DÉTAIL CONSULTATION</div>
                  <div className="section-content">
                    {actesConsultation.map((acte, index) => (
                      <div key={index} className="item-line">
                        <span className="item-nom">{acte.nom || acte.name || 'Acte médical'}</span>
                        <span className="item-prix">
                          {/* CORRECTION ICI */}
                          {(acte.montant || acte.prix || 0).toLocaleString()} FCFA
                        </span>
                      </div>
                    ))}
                    <div className="section-total consultation-total">
                      <span>Total Consultation:</span>
                      <span className="total-amount">{totalActes.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {(analysesAfficher.length > 0 && actesConsultation.length === 0) && (
              <div className="single-section">
                <div className="single-section-content analyses-section-adjacent">
                  <div className="section-title analyses-title">DÉTAIL DES ANALYSES</div>
                  <div className="section-content">
                    {analysesAfficher.map((analyse, index) => (
                      <div key={index} className="item-line">
                        <span className="item-nom">{analyse.nom || 'Analyse'}</span>
                        <span className="item-prix">
                          {(analyse.prix || 0).toLocaleString()} FCFA
                        </span>
                      </div>
                    ))}
                    <div className="section-total analyses-total">
                      <span>Total Analyses:</span>
                      <span>{totalAnalyses.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Montant total et mode paiement */}
            <div className="total-payment-section">
              {/* Afficher les totaux partiels si les deux sections existent */}
              {(actesConsultation.length > 0 && analysesAfficher.length > 0) && (
                <div className="partial-totals">
                  <div className="partial-total">
                    <span>Consultation:</span>
                    <span>{totalActes.toLocaleString()} FCFA</span>
                  </div>
                  <div className="partial-total">
                    <span>Analyses:</span>
                    <span>{totalAnalyses.toLocaleString()} FCFA</span>
                  </div>
                </div>
              )}

              <div className="total-line">
                <span className="total-label">Montant Total:</span>
                <span className="total-value">{montantTotal.toLocaleString()} FCFA</span>
              </div>

            </div>
          </div>

          <div className="pdf-footer">
            {/*<div className="signature-area">
              <div className="signature-line-pdf"></div>
              <p className="signature-text">Cachet et Signature</p>
            </div>*/}
            <div className="copy-label-pdf">
              <strong>Copie Client</strong>
            </div>
          </div>
        </div>

        {/* Copie Archive (identique à la copie Client) */}
        <div className="pdf-copy-a5 archive-copy">
          <div className="pdf-header">
            <img src={LogoHpa} alt="LNE" className="pdf-logo" />
            <div className="pdf-title">
              <h2>LNE - Ndjamena</h2>
            </div>
          </div>

          <div className="pdf-info">
            <div className="pdf-number">
              <strong>REÇU N°: {ClientData.numClient}</strong>
            </div>
          </div>

          <div className="Client-info-pdf">
            {/* Informations Client */}
            <div className="info-basics">
              <div className="info-line">
                <span className="label">Nom du Client:</span>
                <span className="value">{ClientData.nomClient}</span>
                <span>' ---- '</span>
                <span className="label">Téléphone:</span>
                <span className="value">{ClientData.numAirTel || 'N/A'}</span>
                <span>' ---- '</span>
                Date: {new Date(ClientData.dateCreation || ClientData.dateModification || new Date()).toLocaleDateString('fr-FR')}
                <span>' ---- '</span>
                Heure: {new Date(ClientData.dateCreation || ClientData.dateModification || new Date()).toLocaleTimeString('fr-FR')}
              </div>
            </div>

            {/* Sections adjacentes : Détail Consultation et/ou Détail Analyses */}
            <div className="adjacent-sections">
              {/* Section Détail Consultation (à gauche si actes existent) */}
              {actesConsultation.length > 0 && (
                <div className="consultation-section-adjacent">
                  <div className="section-title consultation-title">DÉTAIL CONSULTATION</div>
                  <div className="section-content">
                    {actesConsultation.map((acte, index) => (
                      <div key={index} className="item-line">
                        <span className="item-nom">{acte.nom || acte.name || 'Acte médical'}</span>
                        <span className="item-prix">
                          {/* CORRECTION ICI AUSSI */}
                          {(acte.montant || acte.prix || 0).toLocaleString()} FCFA
                        </span>
                      </div>
                    ))}
                    <div className="section-total consultation-total">
                      <span>Total Consultation:</span>
                      {/* CORRECTION ICI : Remplacer actesSelectionnes par totalActes */}
                      <span className="total-amount">{totalActes.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              )}

              {/* Section Détail Analyses (à droite si analyses existent) */}
              {analysesAfficher.length > 0 && (
                <div className="analyses-section-adjacent">
                  <div className="section-title analyses-title">DÉTAIL DES ANALYSES</div>
                  <div className="section-content">
                    {analysesAfficher.map((analyse, index) => (
                      <div key={index} className="item-line">
                        <span className="item-nom">{analyse.nom || 'Analyse'}</span>
                        <span className="item-prix">
                          {(analyse.prix || 0).toLocaleString()} FCFA
                        </span>
                      </div>
                    ))}
                    <div className="section-total analyses-total">
                      <span>Total Analyses:</span>
                      <span>{totalAnalyses.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Si seulement une section existe, elle prend toute la largeur */}
            {(actesConsultation.length > 0 && analysesAfficher.length === 0) && (
              <div className="single-section">
                <div className="single-section-content consultation-section-adjacent">
                  <div className="section-title consultation-title">DÉTAIL CONSULTATION</div>
                  <div className="section-content">
                    {actesConsultation.map((acte, index) => (
                      <div key={index} className="item-line">
                        <span className="item-nom">{acte.nom || acte.name || 'Acte médical'}</span>
                        <span className="item-prix">
                          {/* CORRECTION ICI */}
                          {(acte.montant || acte.prix || 0).toLocaleString()} FCFA
                        </span>
                      </div>
                    ))}
                    <div className="section-total consultation-total">
                      <span>Total Consultation:</span>
                      <span className="total-amount">{totalActes.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {(analysesAfficher.length > 0 && actesConsultation.length === 0) && (
              <div className="single-section">
                <div className="single-section-content analyses-section-adjacent">
                  <div className="section-title analyses-title">DÉTAIL DES ANALYSES</div>
                  <div className="section-content">
                    {analysesAfficher.map((analyse, index) => (
                      <div key={index} className="item-line">
                        <span className="item-nom">{analyse.nom || 'Analyse'}</span>
                        <span className="item-prix">
                          {(analyse.prix || 0).toLocaleString()} FCFA
                        </span>
                      </div>
                    ))}
                    <div className="section-total analyses-total">
                      <span>Total Analyses:</span>
                      <span>{totalAnalyses.toLocaleString()} FCFA</span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Montant total et mode paiement */}
            <div className="total-payment-section">
              {/* Afficher les totaux partiels si les deux sections existent */}
              {(actesConsultation.length > 0 && analysesAfficher.length > 0) && (
                <div className="partial-totals">
                  <div className="partial-total">
                    <span>Consultation:</span>
                    <span>{totalActes.toLocaleString()} FCFA</span>
                  </div>
                  <div className="partial-total">
                    <span>Analyses:</span>
                    <span>{totalAnalyses.toLocaleString()} FCFA</span>
                  </div>
                </div>
              )}

              <div className="total-line">
                <span className="total-label">Montant Total:</span>
                <span className="total-value">{montantTotal.toLocaleString()} FCFA</span>
              </div>

            </div>
          </div>

          <div className="pdf-footer">
            {/*<div className="signature-area">
              <div className="signature-line-pdf"></div>
              <p className="signature-text">Cachet et Signature</p>
            </div>*/}
            <div className="copy-label-pdf">
              <strong>Copie ARCHIVE</strong>
            </div>
          </div>
        </div>        
      </div>
    </div>
  );
};

export default genererPDF;